import React from 'react'
import PropTypes from 'prop-types'

import CSSModules from 'react-css-modules'

import theme from './PanelSection.scss'

const PanelSection = (props) => {
  let classes = {
    ...props.theme,
    ...theme
  }

  return (
    <div class={Object.values(classes).join(' ')}>
      {props.children}
    </div>
  )
}

PanelSection.propTypes = {
  theme: PropTypes.object,
  children: PropTypes.array
}

export default CSSModules(PanelSection, theme)
